import data from './data.json';
import type { AddressRule } from './types';

const rules = data as unknown as Record<string, AddressRule>;

export function getAddressRule(country: string): AddressRule {
  if (!country) return rules.DEFAULT;
  const code = country.toUpperCase();
  return rules[code] ?? { ...rules.DEFAULT, country: code };
}

export { formatSingleAddress, formatFieldValue } from './format';
export type { AddressRule, SubFieldKey, FieldWidth } from './types';
